import MopMultiSelect from './MopMultiSelect.vue';
export default MopMultiSelect;